export default __webpack_public_path__ + "be80fbd03c8d54c85162369d1d5bc214.png";